import {
  ALLOCATE_PLA_FAILURE,
  ALLOCATE_PLA_REQUEST,
  ALLOCATE_PLA_SUCCESS,
  DEFER_SLP_FAILURE,
  DEFER_SLP_REQUEST,
  DEFER_SLP_SUCCESS,
  GET_AUDIT_TRAIL_LIST_FAILURE,
  GET_AUDIT_TRAIL_LIST_REQUEST,
  GET_AUDIT_TRAIL_LIST_SUCCESS,
  GET_CONTACT_NOTE_FAILURE,
  GET_CONTACT_NOTE_REQUEST,
  GET_CONTACT_NOTE_SUCCESS,
  DELETE_COMPLETED_SLP_FAILURE,
  DELETE_COMPLETED_SLP_REQUEST,
  DELETE_COMPLETED_SLP_SUCCESS,
  GET_COMPLETED_SLP_DETAILS_FAILURE,
  GET_COMPLETED_SLP_DETAILS_REQUEST,
  GET_COMPLETED_SLP_DETAILS_SUCCESS,
  NEXT_OR_CURRENT_SLP_FAILURE,
  NEXT_OR_CURRENT_SLP_REQUEST,
  NEXT_OR_CURRENT_SLP_SUCCESS,
  GET_ALL_SLP_GOALS_AND_ASSESSMENT_REQUEST,
  GET_ALL_SLP_GOALS_AND_ASSESSMENT_SUCCESS,
  GET_ALL_SLP_GOALS_AND_ASSESSMENT_FAILURE,
  UPDATE_CONTACT_DATE_REQUEST,
  UPDATE_CONTACT_DATE_SUCCESS,
  UPDATE_CONTACT_DATE_FAILURE,
} from "./actionTypes";
import {
  AllocatePLAFailure,
  AllocatePLAFailurePayload,
  AllocatePLAPayload,
  AllocatePLARequest,
  AllocatePLASuccess,
  AllocatePLASuccessPayload,
  CompletedSLPDetailsFailurePayload,
  CompletedSLPDetailsPayload,
  CompletedSLPDetailsSuccessPayload,
  DeferSLPFailure,
  DeferSLPFailurePayload,
  DeferSLPPayload,
  DeferSLPRequest,
  DeferSLPSuccess,
  DeferSLPSuccessPayload,
  GetAuditTrailListFailure,
  GetAuditTrailListFailurePayload,
  GetAuditTrailListPayload,
  GetAuditTrailListRequest,
  GetAuditTrailListSuccess,
  GetAuditTrailListSuccessPayload,
  GetContactNoteFailure,
  GetContactNoteFailurePayload,
  GetContactNotePayload,
  GetContactNoteRequest,
  GetContactNoteSuccess,
  GetContactNoteSuccessPayload,
  DeleteCompletedSLPFailure,
  DeleteCompletedSLPFailurePayload,
  DeleteCompletedSLPPayload,
  DeleteCompletedSLPRequest,
  DeleteCompletedSLPSuccess,
  DeleteCompletedSLPSuccessPayload,
  GetCompletedSLPDetailsFailure,
  GetCompletedSLPDetailsRequest,
  GetCompletedSLPDetailsSuccess,
  NextOrCurrentSLPFailure,
  NextOrCurrentSLPFailurePayload,
  NextOrCurrentSLPPaylod,
  NextOrCurrentSLPRequest,
  NextOrCurrentSLPSuccess,
  NextOrCurrentSLPSuccessPayload,
  GetAllSLPGoalsAndAssessmentPayload,
  GetAllSLPGoalsAndAssessmentRequest,
  GetAllSLPGoalsAndAssessmentSuccessPayload,
  GetAllSLPGoalsAndAssessmentSuccess,
  GetAllSLPGoalsAndAssessmentFailurePayload,
  GetAllSLPGoalsAndAssessmentFailure,
  IUpdateContactDateRequestPayload,
  UpdateContactDateRequest,
  IUpdateContactDateSuccessPayload,
  IUpdateContactDateFailurePayload,
  UpdateContactDateSuccess,
  UpdateContactDateFailure,
} from "./types";

export const nextOrCurrentSLPRequest = (
  payload: NextOrCurrentSLPPaylod
): NextOrCurrentSLPRequest => ({
  type: NEXT_OR_CURRENT_SLP_REQUEST,
  payload,
});

export const nextOrCurrentSLPSuccess = (
  payload: NextOrCurrentSLPSuccessPayload
): NextOrCurrentSLPSuccess => ({
  type: NEXT_OR_CURRENT_SLP_SUCCESS,
  payload,
});

export const nextOrCurrentSLPFailure = (
  payload: NextOrCurrentSLPFailurePayload
): NextOrCurrentSLPFailure => ({
  type: NEXT_OR_CURRENT_SLP_FAILURE,
  payload,
});

export const deferSLPRequest = (payload: DeferSLPPayload): DeferSLPRequest => ({
  type: DEFER_SLP_REQUEST,
  payload,
});

export const deferSLPSuccess = (
  payload: DeferSLPSuccessPayload
): DeferSLPSuccess => ({
  type: DEFER_SLP_SUCCESS,
  payload,
});

export const deferSLPFailure = (
  payload: DeferSLPFailurePayload
): DeferSLPFailure => ({
  type: DEFER_SLP_FAILURE,
  payload,
});

export const allocatePLARequest = (
  payload: AllocatePLAPayload
): AllocatePLARequest => ({
  type: ALLOCATE_PLA_REQUEST,
  payload,
});

export const allocatePLASuccess = (
  payload: AllocatePLASuccessPayload
): AllocatePLASuccess => ({
  type: ALLOCATE_PLA_SUCCESS,
  payload,
});

export const allocatePLAFailure = (
  payload: AllocatePLAFailurePayload
): AllocatePLAFailure => ({
  type: ALLOCATE_PLA_FAILURE,
  payload,
});

export const getContactNoteRequest = (
  payload: GetContactNotePayload
): GetContactNoteRequest => ({
  type: GET_CONTACT_NOTE_REQUEST,
  payload,
});

export const getContactNoteSuccess = (
  payload: GetContactNoteSuccessPayload
): GetContactNoteSuccess => ({
  type: GET_CONTACT_NOTE_SUCCESS,
  payload,
});

export const getContactNoteFailure = (
  payload: GetContactNoteFailurePayload
): GetContactNoteFailure => ({
  type: GET_CONTACT_NOTE_FAILURE,
  payload,
});

export const getAuditTrailListRequest = (
  payload: GetAuditTrailListPayload
): GetAuditTrailListRequest => ({
  type: GET_AUDIT_TRAIL_LIST_REQUEST,
  payload,
});

export const getAuditTrailListSuccess = (
  payload: GetAuditTrailListSuccessPayload
): GetAuditTrailListSuccess => ({
  type: GET_AUDIT_TRAIL_LIST_SUCCESS,
  payload,
});

export const getAuditTrailFailure = (
  payload: GetAuditTrailListFailurePayload
): GetAuditTrailListFailure => ({
  type: GET_AUDIT_TRAIL_LIST_FAILURE,
  payload,
});

export const deleteCompletedSLPRequest = (
  payload: DeleteCompletedSLPPayload
): DeleteCompletedSLPRequest => ({
  type: DELETE_COMPLETED_SLP_REQUEST,
  payload,
});

export const deleteCompletedSLPSuccess = (
  payload: DeleteCompletedSLPSuccessPayload
): DeleteCompletedSLPSuccess => ({
  type: DELETE_COMPLETED_SLP_SUCCESS,
  payload,
});

export const deleteCompletedSLPFailure = (
  payload: DeleteCompletedSLPFailurePayload
): DeleteCompletedSLPFailure => ({
  type: DELETE_COMPLETED_SLP_FAILURE,
  payload,
});

export const getCompletedSLPDetailsRequest = (
  payload: CompletedSLPDetailsPayload
): GetCompletedSLPDetailsRequest => ({
  type: GET_COMPLETED_SLP_DETAILS_REQUEST,
  payload,
});

export const getCompletedSLPDetailsSuccess = (
  payload: CompletedSLPDetailsSuccessPayload
): GetCompletedSLPDetailsSuccess => ({
  type: GET_COMPLETED_SLP_DETAILS_SUCCESS,
  payload,
});

export const getCompletedSLPDetailsFailure = (
  payload: CompletedSLPDetailsFailurePayload
): GetCompletedSLPDetailsFailure => ({
  type: GET_COMPLETED_SLP_DETAILS_FAILURE,
  payload,
});

export const getAllSLPGoalsAndAssessmentRequest = (
  payload: GetAllSLPGoalsAndAssessmentPayload
): GetAllSLPGoalsAndAssessmentRequest => ({
  type: GET_ALL_SLP_GOALS_AND_ASSESSMENT_REQUEST,
  payload,
});

export const getAllSLPGoalsAndAssessmentSuccess = (
  payload: GetAllSLPGoalsAndAssessmentSuccessPayload
): GetAllSLPGoalsAndAssessmentSuccess => ({
  type: GET_ALL_SLP_GOALS_AND_ASSESSMENT_SUCCESS,
  payload,
});

export const getAllSLPGoalsAndAssessmentFailure = (
  payload: GetAllSLPGoalsAndAssessmentFailurePayload
): GetAllSLPGoalsAndAssessmentFailure => ({
  type: GET_ALL_SLP_GOALS_AND_ASSESSMENT_FAILURE,
  payload,
});

export const updateContactDateRequest = (
  payload: IUpdateContactDateRequestPayload
): UpdateContactDateRequest => ({
  type: UPDATE_CONTACT_DATE_REQUEST,
  payload,
});

export const updateContactDateSuccess = (
  payload: IUpdateContactDateSuccessPayload
): UpdateContactDateSuccess => ({
  type: UPDATE_CONTACT_DATE_SUCCESS,
  payload,
});

export const updateContactDateFailure = (
  payload: IUpdateContactDateFailurePayload
): UpdateContactDateFailure => ({
  type: UPDATE_CONTACT_DATE_FAILURE,
  payload,
});
